export default function prepareQueryString(props: { [key: string]: unknown }) {
  const queryString = new URLSearchParams();

  Object.entries(props).forEach(([key, value]) => {
    if (value) queryString.append(key, String(value));
  });

  return queryString.toString();
}
